import React, { useState, useEffect } from "react";

const API_BASE = window.location.origin;
const HOME_BASE = window.location.origin;



function BlogContent({ postId }) {
  const [post, setPost] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/fetch_post/${postId}`);
        const data = await response.json();
        setPost(data.post);
      } catch (error) {
        console.error("Error fetching blog post:", error);
      }
    };

    fetchPost();
  }, [postId]);

  if (!post) {
    return <div>Loading...</div>;
  }

  return (
    <div className="blog-content">
      <h1>{post.title}</h1>



<div
  className="blog-post-body"
  style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
>
  {post.content}
</div>





      <button
        className="homepage-button"
        onClick={() => (window.location.href = `${HOME_BASE}/`)}
      >
        Go to Homepage
      </button>
    </div>
  );
  
}

export default BlogContent;
